/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-switch/webhook-form-switch.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
}
/*# sourceMappingURL=webhook-form-switch.component.css.map */
